/**
 * compact.ts - Compact FileMaker-style skin
 * 
 * CHANGE HISTORY:
 * - 251122_2330 danielbeer: Created compact skin with FileMaker-like spacing
 * 
 * Designed for maximum information density with minimal spacing,
 * similar to traditional FileMaker layouts.
 */

export const compactSkin = {
  id: 'compact',
  name: 'Compact (FileMaker Style)',
  description: 'Dense layout with minimal spacing - label 10px, field 11px, 2px padding',
  mode: 'light',
  variables: {
    // Typography - FileMaker-like sizes
    'font-family': '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    'font-size-base': '11px',           // Field/content size
    'font-size-label': '10px',          // Label size
    'font-size-small': '9px',
    'font-size-large': '12px',
    'font-weight-normal': '400',
    'font-weight-medium': '500',
    'font-weight-bold': '600',
    'line-height': '1.3',               // Tighter line height
    
    // Spacing - Minimal padding
    'spacing-xs': '1px',
    'spacing-sm': '2px',                // Primary padding
    'spacing-md': '4px',
    'spacing-lg': '6px',
    'spacing-xl': '8px',
    'spacing-xxl': '12px',
    
    // Layout - Compact dimensions
    'padding': '2px',                   // Default padding
    'padding-input': '2px 4px',         // Input field padding
    'padding-button': '2px 6px',        // Button padding
    'gap': '4px',                       // Gap between elements
    'row-height': '20px',               // Compact row height
    'label-size': '10px',               // Label font size
    'field-size': '11px',               // Field font size
    
    // Border radius - Minimal
    'border-radius-sm': '2px',
    'border-radius-md': '3px',
    'border-radius-lg': '4px',
    
    // Colors - Clean and professional
    'color-background': '#ffffff',
    'color-surface': '#f8f9fa',
    'color-border': '#d1d5db',
    'color-text-primary': '#1f2937',
    'color-text-secondary': '#6b7280',
    'color-text-tertiary': '#9ca3af',
    
    // Primary colors
    'color-primary': '#2563eb',
    'color-primary-hover': '#1d4ed8',
    'color-primary-light': '#dbeafe',
    
    // Status colors
    'color-success': '#10b981',
    'color-success-light': '#d1fae5',
    'color-error': '#ef4444',
    'color-error-light': '#fee2e2',
    'color-warning': '#f59e0b',
    'color-warning-light': '#fef3c7',
    'color-info': '#3b82f6',
    'color-info-light': '#dbeafe',
    
    // Component-specific
    'bg-hover': 'rgba(0, 0, 0, 0.03)',
    'bg-active': 'rgba(0, 0, 0, 0.05)',
    'bg-selected': '#dbeafe',
    
    // Shadows - Subtle
    'shadow-sm': '0 1px 2px rgba(0, 0, 0, 0.05)',
    'shadow-md': '0 2px 4px rgba(0, 0, 0, 0.08)',
    'shadow-lg': '0 4px 6px rgba(0, 0, 0, 0.1)',
    
    // Transitions
    'transition-fast': '100ms',
    'transition-base': '150ms',
    'transition-slow': '200ms',
    
    // Grid/Table specific - Very compact
    'ag-row-height': '22px',
    'ag-header-height': '24px',
    'ag-font-size': '11px',
    'ag-cell-horizontal-padding': '2px',
    'ag-cell-vertical-padding': '1px'
  }
};

export default compactSkin;
